import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';

// ==============================|| PAGE LOADER (thin bar at the very top) ||============================== //

export default function Loader() {
  return (
    <Box sx={{ position: 'fixed', top: 0, left: 0, zIndex: 2001, width: 1 }}>
      <LinearProgress color="primary" sx={{ height: 2, borderRadius: 0, bgcolor: 'transparent', '& .MuiLinearProgress-bar': { borderRadius: 0 } }} />
    </Box>
  );
}
